import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=934513b6&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=934513b6&prod&lang=scss&scoped=true"
import style1 from "./Promotions.vue?vue&type=style&index=1&id=934513b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934513b6",
  null
  
)

export default component.exports